module.exports = __webpack_public_path__ + "static/media/mobileMenu.ef502e13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Container/components/Menu/img/mobileMenu.svg
// module id = 135
// module chunks = 0